'use strict';

namespace CMS {

    class CmsUtils {

        reWhitespace = /\s/g;

        normaliseValue (val): string {
            return decodeURIComponent(String(val))
                .toLowerCase()
                .replace(this.reWhitespace, '');
        }

        propsMatch(srcOb, props): boolean {
        // Returns `true` if all `props` k:v pairs have a normalised match in `srcOb`
            if (!angular.isObject(srcOb) || !angular.isObject(props)) {
                return false;
            }
            let matchCount = 0;
            const srcKeys = Object.keys(srcOb);
            const propsKeys = Object.keys(props);
            let pi = propsKeys.length;

            while (pi--) {
                let si = srcKeys.length;
                const normalisedKey = this.normaliseValue(propsKeys[pi]);
                const normalisedVal = this.normaliseValue(props[propsKeys[pi]]);
                while (si--) {
                    if (
                        this.normaliseValue(srcKeys[si]) === normalisedKey &&
                        this.normaliseValue(srcOb[srcKeys[si]]) === normalisedVal
                    ) {
                        if (++matchCount === propsKeys.length) {
                            return true;
                        }
                        break;
                    }
                }
            };
            return false;
        }
    }

    angular
        .module('cms')
        .service('cmsUtils', CmsUtils);
}
